import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const h = {
  display: "block"
}, m = ({ size: a = 16, useVw: n, useRem: o, color: c, withColor: l, removeClassName: t, disableSSR: d, style: i, ...p }) => {
  const v = i ? { ...h, ...i } : h;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: d }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-zhifuzhanghu", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: v, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-æ¯ä»è´¦æ·"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: t ? "" : "normal",
        d: "M3.551 10.25a4.782 4.782 0 0 1 4.782-4.781h15.334c2.64 0 4.781 2.14 4.781 4.782v.638a.949.949 0 0 1-1.896 0v-.638a2.885 2.885 0 0 0-2.885-2.885H8.333a2.885 2.885 0 0 0-2.885 2.885v11.5a2.885 2.885 0 0 0 2.885 2.884h15.334a2.885 2.885 0 0 0 2.884-2.885v-4.63c0-.888-.72-1.607-1.607-1.607H10.81a2.785 2.785 0 0 1 0-5.571h11.58c1.23 0 2.226.997 2.226 2.226v1.448h.33a3.504 3.504 0 0 1 3.503 3.504v4.631a4.781 4.781 0 0 1-4.781 4.782H8.333a4.782 4.782 0 0 1-4.782-4.782v-11.5Zm19.167 3.365v-1.448a.33.33 0 0 0-.33-.33h-11.58a.888.888 0 1 0 0 1.778h11.91Z",
        fillRule: "evenodd",
        fill: l ? r(c, 0, "#0B0C0D") : "#0B0C0D",
        datafollowfill: l ? r(c, 0, "#0B0C0D") : "#0B0C0D"
      }
    )
  )));
}, s = m;
export {
  s as default
};
